// extracted by mini-css-extract-plugin
export default {"body":"styles_body__Nxr2V","content":"styles_content__Tq0Dm","details":"styles_details__nuplC","actions":"styles_actions__2G0U9"};